import React from "react";

const Profile = React.lazy(() => import("../pages/profile"));
const BuySubscriptionProfile = React.lazy(() =>
  import("../pages/profile/Subscriptions")
);

const WalletsList = React.lazy(() => import("../pages/wallet/WalletsList"));
const WalletDetail = React.lazy(() => import("../pages/wallet/WalletDetail"));

const PaymentResault = React.lazy(() =>
  import("../pages/payment/PaymentResault")
);
const BuySubscribtion = React.lazy(() =>
  import("../pages/Loans/BuySubscribtion")
);

const ReferallCode = React.lazy(() => import("../pages/referallCode/index"));
const GetShebaLanding = React.lazy(() =>
  import("../pages/error/GetShebaLanding")
);
const Rightel = React.lazy(() => import("../pages/Rightel"));
const RightelSimcardDetail = React.lazy(() =>
  import("../pages/Rightel/SelectedSimcardDetail")
);
const RightelRegister = React.lazy(() =>
  import("../pages/Rightel/RightelRegister")
);
const RightelUserInfo = React.lazy(() =>
  import("../pages/Rightel/UserInformation")
);

const Entertainment = React.lazy(() => import("../pages/Entertainment"));
const Poll = React.lazy(() => import("../pages/poll"));
const BankPayment = React.lazy(() => import("../pages/payment/BankPayment"));
const TransactionHistory = React.lazy(() =>
  import("../pages/profile/TransactionHistory")
);
const ProfileUserInformation = React.lazy(() =>
  import("../pages/profile/UserInformation")
);

const ScoresAndDiscountCode = React.lazy(() =>
  import("../pages/profile/scoresAndDiscountCode")
);
const Lottery = React.lazy(() => import("../pages/profile/lottery"));

const Kadona = React.lazy(() => import("../pages/kadona/index"));
const KadonaSuggested = React.lazy(() =>
  import("../pages/kadona/suggestedCard")
);
const KadonaFavorite = React.lazy(() =>
  import("../pages/kadona/FavoriteGiftCard")
);
const CardConfig = React.lazy(() => import("../pages/kadona/CardConfig"));
const RecieverData = React.lazy(() => import("../pages/kadona/RecieverData"));

const CarServices = React.lazy(() =>
  import("../pages/services/carServices/index")
);

const CarFreeway = React.lazy(() =>
  import("../pages/services/carServices/freeway")
);
const CarVioltion = React.lazy(() =>
  import("../pages/services/carServices/violation")
);
const CarVioltionPlaque = React.lazy(() =>
  import("../pages/services/carServices/violation/EnterPlaque")
);
const CarNegativePoint = React.lazy(() =>
  import("../pages/services/carServices/negativePoints")
);
const CarNegativePointResult = React.lazy(() =>
  import("../pages/services/carServices/negativePoints/negativePointResult")
);
const CarLicenseSituation = React.lazy(() =>
  import("../pages/services/carServices/drivingLicenseSituation")
);

const DirectDebitBankList = React.lazy(() => import("../pages/directDebit"));
const DirectDebitResult = React.lazy(() =>
  import("../pages/directDebit/DirectDebitResult")
);

const PaymentInternalGateway = React.lazy(() =>
  import("../pages/payment/PaymentGateway")
);

export const privateRoutes = [
  { path: "/profile", element: <Profile /> },
  { path: "/wallets", element: <WalletsList /> },
  { path: "/wallet", element: <WalletDetail /> },
  { path: "/paymentresault", element: <PaymentResault /> },
  { path: "/buysubscribtion", element: <BuySubscribtion /> },
  {
    path: "/profile/buySubscription",
    element: <BuySubscriptionProfile />,
  },
  {
    path: "/profile/discount-scores",
    element: <ScoresAndDiscountCode />,
  },
  {
    path: "/profile/lottery",
    element: <Lottery />,
  },
  { path: "/profile/direct-debit", element: <DirectDebitBankList /> },
  { path: "/profile/tranaction-history", element: <TransactionHistory /> },
  { path: "/profile/information", element: <ProfileUserInformation /> },

  { path: "/poll", element: <Poll /> },
  { path: "/referall", element: <ReferallCode /> },
  { path: "/money-return/:id", element: <GetShebaLanding /> },

  { path: "/rightel", element: <Rightel /> },
  { path: "/rightel/detail", element: <RightelSimcardDetail /> },
  { path: "/rightel/register", element: <RightelRegister /> },
  { path: "/rightel/user-info/:currentStep", element: <RightelUserInfo /> },

  { path: "/entertainment", element: <Entertainment /> },
  { path: "/payment/:id", element: <BankPayment /> },

  { path: "/kadona", element: <Kadona /> },
  { path: "/kadona/suggested", element: <KadonaSuggested /> },
  { path: "/kadona/favorite", element: <KadonaFavorite /> },
  { path: "/kadona/card-config", element: <CardConfig /> },
  { path: "/kadona/send-settings", element: <RecieverData /> },

  { path: "/car", element: <CarServices /> },
  { path: "/car/freeway", element: <CarFreeway /> },
  { path: "/car/violation", element: <CarVioltion /> },
  { path: "/car/violation/plaque", element: <CarVioltionPlaque /> },
  { path: "/car/negative-point", element: <CarNegativePoint /> },
  { path: "/car/negative-point/result", element: <CarNegativePointResult /> },
  { path: "/car/license-situation", element: <CarLicenseSituation /> },
  {
    path: "/car/license-situation/result",
    element: <CarNegativePointResult />,
  },

  { path: "/direct-debit/result", element: <DirectDebitResult /> },
  { path: "/payment-gateway", element: <PaymentInternalGateway /> },
];
